module.exports = __webpack_public_path__ + "edit.png?65fb866c70d74abd39c273f4799b2351";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit.png
// module id = 77
// module chunks = 0